import { render } from "./CardTimer.vue?vue&type=template&id=3066e33c&scoped=true"
import script from "./CardTimer.vue?vue&type=script&lang=js"
export * from "./CardTimer.vue?vue&type=script&lang=js"

import "./CardTimer.vue?vue&type=style&index=0&id=3066e33c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3066e33c"]])

export default __exports__